import { Upload } from "@mui/icons-material";
import { Box, Icon, Stack } from "@mui/material";
import { useState } from "react";
import { useDropzone } from "react-dropzone";

interface UploadersProps {
  title: string | null;
  subtitle: string | null;
  activateWebcam?: () => void;
  onDrop: (acceptedFiles: File[]) => void;
  subImageTextOne: string | null;
  subImageTextTwo: string | null;
  subImageTextMobile: string | null;
  isLoading: boolean;
}

const Uploaders = ({ onDrop }: UploadersProps) => {
  const [, setIsDraggingOver] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDragEnter: () => setIsDraggingOver(true),
    onDragLeave: () => setIsDraggingOver(false),
  });

  return (
    <Box>
      <Stack direction={"row"} gap={2}>
        <>
          <div {...getRootProps()} style={{ width: "100%" }}>
            <input {...getInputProps()} />
            <Box
              border="#FF8175 2px dashed"
              height={"200px"}
              width="100%"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon
                color="secondary"
                fontSize="large"
                sx={{ alignSelf: "center" }}
              >
                <Upload fontSize="large" />
              </Icon>
            </Box>
          </div>
        </>
      </Stack>
    </Box>
  );
};

export default Uploaders;
